import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';

import {
    getTokenPayload,
    getValidIdToken,
    isAuthenticated,
} from './cookie-auth';
import { FrontendUpdateNotice } from './components/FrontendUpdateNotice';
import { refreshIdToken } from './auth-refresh';
import { getLoginUrl } from './helpers/loginUrl';
import { MissingBusinessSlugPage } from './pages/MissingBusinessSlugPage';
import { StaffImportPage } from './pages/StaffImportPage';

const redirectToMainAppLogin = () => {
    window.location.replace(getLoginUrl());
};

const App = () => {
    const [email, setEmail] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            if (!isAuthenticated()) {
                redirectToMainAppLogin();
                return;
            }

            const idToken = await getValidIdToken(refreshIdToken);
            if (!idToken) {
                redirectToMainAppLogin();
                return;
            }

            const payload = getTokenPayload(idToken);
            if (!payload?.email) {
                redirectToMainAppLogin();
                return;
            }

            setEmail(payload.email);
            setLoading(false);
        };

        checkAuth();
    }, []);

    if (loading || !email) {
        return (
            <p
                style={{
                    fontFamily: 'Montserrat, sans-serif',
                    padding: '2rem',
                }}
            >
                Loading...
            </p>
        );
    }

    return (
        <>
            <FrontendUpdateNotice />
            <Switch>
                <Route path="/:businessName">
                    <StaffImportPage email={email} />
                </Route>
                <Route exact path="/">
                    <MissingBusinessSlugPage />
                </Route>
            </Switch>
        </>
    );
};

export default App;
